import { PropsWithChildren } from 'react';
import { observer } from 'mobx-react-lite';

import { SignInPage } from '../../../pages/sign-in/sign-in.page';
import { authStore } from '../auth.store';

export const AuthGuard = observer(({ children }: PropsWithChildren) => {
  return authStore.hasAuth ? <>{children}</> : <SignInPage />;
});
